export const BY_MIN_PRICE = 'BY_MIN_PRICE';
export const BY_MAX_PRICE = 'BY_MAX_PRICE';
// FE-14: в макете три режима сортировки над списком, а не «цена по возрастанию/убыванию»
export const BY_DURATION = 'BY_DURATION';
export const BY_DEPARTURE_TIME = 'BY_DEPARTURE_TIME';
